import React from 'react';
import { useFormikContext } from 'formik';
import isEqual from 'lodash.isequal';
import { CreateArtistValues } from '../../utils/form/artistForm';
import { getPermissionsFromSelectedRoles } from '../../helpers/employees';
import useUser from '../../hooks/global/useUser';

/**
 * This component is used to handle the permissions of the artist
 * It will update the formik values with the permissions based on the selected roles
 */
function NewEditArtistRolesHandler() {
  const { user } = useUser();
  const { values, initialValues, setFieldValue } =
    useFormikContext<CreateArtistValues>();

  const previousSelectedRoleRef = React.useRef(initialValues.selectedRoles);
  const valuesRef = React.useRef(values);
  const userRef = React.useRef(user);

  const selectedRoles = React.useMemo(
    () => values.selectedRoles,
    [values.selectedRoles],
  );

  React.useEffect(() => {
    userRef.current = user;
  }, [user]);

  React.useEffect(() => {
    valuesRef.current = values;
  }, [values]);

  React.useEffect(() => {
    // Only run if selectedRoles has changed
    if (isEqual(previousSelectedRoleRef.current, selectedRoles)) return;
    const newPermission = getPermissionsFromSelectedRoles(
      previousSelectedRoleRef.current ?? [],
      selectedRoles ?? [],
      valuesRef.current,
      userRef.current,
    );
    Object.entries(newPermission).forEach(([key, value]: [string, boolean]) => {
      setFieldValue(key, value);
    });
    previousSelectedRoleRef.current = selectedRoles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRoles]);

  return null;
}

export default NewEditArtistRolesHandler;
